import { ONBOARDING_INPUT_PROPS } from '@/pages/onboarding/_components/onboarding-field-styles';
import type { InputProps } from '@chakra-ui/react';

/** Label style of the auth page fields (login and sign-up). */
export const authFieldLabelSx = {
  fontFamily: 'var(--chakra-fonts-heading)',
  fontSize: '13px',
  fontWeight: 600,
  color: 'var(--chakra-colors-primary-900)',
} as const;

/** Local auth controls; shared input recipes keep their existing defaults. */
export const authFieldControlProps = {
  ...ONBOARDING_INPUT_PROPS,
  fontSize: { base: '16px', md: '15px' },
  color: 'primary.900',
  _hover: { borderColor: 'gray.400' },
  _focus: {
    borderColor: 'primary.900',
    boxShadow: 'none',
    outline: '2px solid',
    outlineColor: 'primary.900',
    outlineOffset: '2px',
  },
  _focusVisible: {
    borderColor: 'primary.900',
    boxShadow: 'none',
    outline: '2px solid',
    outlineColor: 'primary.900',
    outlineOffset: '2px',
  },
  _invalid: { _focus: { boxShadow: 'none' } },
} satisfies InputProps;
